import { __extends } from "tslib";
import * as React from 'react';
import * as cx from 'classnames';
import * as s from './ColorSample.scss';
import { keyboardEvents } from '../../constants';
var ColorSample = /** @class */ (function (_super) {
    __extends(ColorSample, _super);
    function ColorSample(props) {
        var _this = _super.call(this, props) || this;
        _this.onMouseEnter = function (description) {
            if (_this.isActive() && _this.props.onMouseEnter) {
                _this.props.onMouseEnter(description);
            }
        };
        _this.onMouseLeave = function (e) {
            if (_this.isActive() && _this.props.onMouseLeave) {
                _this.props.onMouseLeave(e);
            }
        };
        _this.onChange = function (e) {
            if (_this.isActive() && _this.props.onChange) {
                _this.props.onFocus(e);
                _this.props.onChange(e);
            }
        };
        _this.onKeyDown = function (e) {
            var increase = [keyboardEvents.ARROW_RIGHT, keyboardEvents.ARROW_UP].map(function (_) { return _.keyCode; });
            var decrease = [keyboardEvents.ARROW_LEFT, keyboardEvents.ARROW_DOWN].map(function (_) { return _.keyCode; });
            var keyCode = e.charCode || e.keyCode;
            if (keyCode === keyboardEvents.ENTER.keyCode) {
                return _this.onChange(e);
            }
            if (!_this.props.onKeyboardArrowEvent) {
                /* istanbul ignore next */
                return;
            }
            if (increase.includes(keyCode)) {
                _this.props.onKeyboardArrowEvent(1);
            }
            if (decrease.includes(keyCode)) {
                _this.props.onKeyboardArrowEvent(-1);
            }
        };
        _this.isfocusableByTab = function () {
            if (_this.props.withTabIndexExperiment) {
                if (_this.props.isAnyColorSelected) {
                    return _this.props.isSelected;
                }
                return true;
            }
            return _this.props.isFirst;
        };
        _this.focus = function () {
            _this.ref.current.focus();
        };
        _this.isActive = function () {
            return !_this.props.isDisabled;
        };
        _this.ref = React.createRef();
        return _this;
    }
    ColorSample.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isFocused && !prevProps.isFocused) {
            this.props.shouldFocus && this.focus();
        }
    };
    ColorSample.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, description = _b.description, isSelected = _b.isSelected, isDisabled = _b.isDisabled, rgbColorValue = _b.rgbColorValue, colorSampleClassName = _b.colorSampleClassName, allowMultiple = _b.allowMultiple;
        var classNames = cx(s.colorSample, (_a = {},
            _a[s.disabled] = !this.isActive(),
            _a), colorSampleClassName);
        return (React.createElement("label", { onMouseEnter: function () { return _this.onMouseEnter(description); }, onMouseLeave: this.onMouseLeave, className: s.label, "data-hook": "color-sample" },
            //eslint-disable-next-line jsx-a11y/role-supports-aria-props
            React.createElement("input", { "aria-label": description, "aria-checked": isSelected, checked: isSelected, tabIndex: this.isfocusableByTab() ? 0 : -1, className: s.input, disabled: isDisabled, onChange: this.onChange, onKeyDown: this.onKeyDown, ref: this.ref, type: allowMultiple ? 'checkbox' : 'radio' }),
            React.createElement("span", { style: { backgroundColor: rgbColorValue }, className: classNames })));
    };
    return ColorSample;
}(React.Component));
export { ColorSample };
//# sourceMappingURL=ColorSample.js.map